import React from 'react';

import { InverseButton as Button } from '@rbilabs/components-library/build/components/button';

type ButtonProps = React.ComponentProps<typeof Button>;

type StoreCardButtonProps = Pick<ButtonProps, 'aria-label' | 'color' | 'startIcon' | 'onClick'>;

export const StoreCardButton: React.FC<StoreCardButtonProps> = ({
  'aria-label': ariaLabel,
  color,
  onClick,
  startIcon,
}) => {
  return (
    <Button
      aria-label={ariaLabel}
      color={color}
      marginWidth={4}
      onClick={onClick}
      startIcon={startIcon}
      transparent
    />
  );
};
